import { emojiFace1, emojiFace2, emojiFace3 } from "~/assets/assets";
import { classNames } from "~/utils/etc";
import { PhosphorIcon } from "~/widgets/icons";

const TrustItems = () => (
  <>
    <div class="flex shrink-0 items-center gap-1 whitespace-nowrap">
      <LightningIcon />
      <p class="text-success-base">
        Instant gift card e-delivery here & on WhatsApp
      </p>
    </div>

    <div class="flex shrink-0 items-center gap-1 whitespace-nowrap">
      <RandomEmojiFaces
        styles={{ emoji: "h-6 w-6", container: "w-16 h-6 contents" }}
      />
      <p class="text-success-dark">5L+ happy users</p>
    </div>

    <div class="flex shrink-0 items-center gap-1 whitespace-nowrap">
      <PiggyBankIcon />
      <p class="text-[var(--color-blue-900)]">Saved ₹10Cr till date</p>
    </div>

    <div class="flex shrink-0 items-center gap-1 whitespace-nowrap">
      <ProtectionIcon />
      <p class="text-[var(--color-purple-900)]">Safe & secure</p>
    </div>
  </>
);

export const TrustMakerStripTelescope = () => {
  return (
    <div class="w-full overflow-hidden rounded-lg bg-[#F7F8FC] py-3 lg:px-8">
      {/* Desktop: static */}
      <div class="hidden lg:flex">
        <div class="flex w-full flex-row items-center justify-between gap-6 text-title-6-semi-bold">
          <TrustItems />
        </div>
      </div>

      {/* Mobile: marquee animation - 2 strips translating 50% */}
      <div class="flex w-max animate-[marquee-half_10s_linear_infinite] lg:hidden">
        <div class="flex shrink-0 items-center gap-6 px-4 text-title-6-semi-bold">
          <TrustItems />
        </div>
        <div class="flex shrink-0 items-center gap-6 px-4 text-title-6-semi-bold">
          <TrustItems />
        </div>
      </div>
    </div>
  );
};

function RandomEmojiFaces(props: {
  styles?: { emoji?: string; container?: string };
}) {
  return (
    <div
      class={classNames(
        props.styles?.container,
        "inline-flex h-10 w-28 items-center justify-start -space-x-1.5 "
      )}
    >
      <img
        class={classNames(
          props.styles?.emoji,
          "h-10 w-10 rounded-full border border-baseTertiaryLight ring-1 ring-baseTertiaryLight"
        )}
        src={emojiFace1}
        alt="Facemoji"
      />
      <img
        class={classNames(
          props.styles?.emoji,
          "h-10 w-10 rounded-full border border-baseTertiaryLight ring-1 ring-baseTertiaryLight"
        )}
        src={emojiFace2}
        alt="Facemoji"
      />
      <img
        class={classNames(
          props.styles?.emoji,
          "h-10 w-10 rounded-full border border-baseTertiaryLight ring-1 ring-baseTertiaryLight"
        )}
        src={emojiFace3}
        alt="Facemoji"
      />
    </div>
  );
}

const PiggyBankIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5 6.5V9.054C19.218 9.702 19.788 10.51 20.126 11.435H21C21.552 11.435 22 11.883 22 12.435V15.5C22 16.052 21.552 16.5 21 16.5H19.689C19.164 17.408 18.406 18.164 17.5 18.691V20.5C17.5 21.052 17.052 21.5 16.5 21.5H14.5C13.948 21.5 13.5 21.052 13.5 20.5V19.5H10V20.368C10 20.92 9.552 21.368 9 21.368H7C6.448 21.368 6 20.92 6 20.368V17.963C4.775 16.864 4 15.275 4 13.5C4 10.186 6.686 7.5 10 7.5H14.526C14.955 7.5 15.371 7.359 15.713 7.101C16.212 6.725 16.828 6.5 17.5 6.5H18.5V6.5Z"
        fill="#182F8B"
      />
      <path
        d="M17.0315 12.4673C17.0495 12.4853 17.0495 12.5143 17.0315 12.5323C17.0135 12.5503 16.9845 12.5503 16.9665 12.5323C16.9485 12.5143 16.9485 12.4853 16.9665 12.4673C16.9845 12.4493 17.0145 12.4503 17.0315 12.4673"
        stroke="#F8F7FA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.662 7.478C14.873 7.027 15 6.53 15 6C15 4.067 13.433 2.5 11.5 2.5C9.567 2.5 8 4.067 8 6C8 6.623 8.176 7.2 8.462 7.706"
        stroke="#182F8B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.288 10.5C1.819 10.773 1.5 11.276 1.5 11.858C1.5 12.729 2.206 13.435 3.077 13.435H4"
        stroke="#182F8B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ProtectionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 10.767C3.5 15.1925 6.2472 19.1532 10.3923 20.7036L10.4223 20.7148C11.4399 21.0954 12.5607 21.095 13.578 20.7138L13.6024 20.7047C17.7512 19.1499 20.5 15.1842 20.5 10.7536V7.03023C20.5 6.15536 19.9314 5.38202 19.0963 5.12118L12.5963 3.09095C12.208 2.96968 11.792 2.96968 11.4037 3.09095L4.90374 5.12112C4.06864 5.38195 3.5 6.15529 3.5 7.03017V10.767Z"
        fill="#3D1D86"
      />
      <path
        d="M10 12L11.5 13.5L14.5 10.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const LightningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.823 11.5753L12.812 20.2583C12.261 21.0533 11.014 20.6643 11.014 19.6963V13.9733H5.98898C5.19298 13.9733 4.72398 13.0793 5.17798 12.4243L11.189 3.74128C11.74 2.94628 12.987 3.33528 12.987 4.30328V10.0263H18.012C18.807 10.0263 19.276 10.9203 18.823 11.5753Z"
        fill="#178C4E"
      />
    </svg>
  );
};
